module.exports = __webpack_public_path__ + "img/bir_md.ecee970b.png";